module.exports = __webpack_public_path__ + "static/media/icon-tick-gray.0ed6948e.svg";